import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { NumericFormat } from "react-number-format";
import * as S from './styled';
//hooks
import useLoading from '../../../../hooks/useLoading';
import apiRequest from '../../../../hooks/apiRequest';
//Components
import LayoutModal from '../../../LayoutModal';
//Interface
import { Inputs } from '../../../../Interfaces/IService';
import { ICreate } from 'Interfaces/ICreate';

export default function CreateService({
  isOpenModal,
  setModalClose,
  refreshFrames,
  setToastData,
  setToastOpen
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  const toUpperCaseStrings = (obj: Record<string, any>) => {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key,
        typeof value === 'string' ? value.toUpperCase() : value,
      ])
    );
  };

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const payload = toUpperCaseStrings(data);
      const response = await apiRequest('service', 'POST', payload);
      if (response.status === 201) {
        setToastData({
          status: response.status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        onClose();

      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  }

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Registrar Serviço"
        subTitle="Cadastre um novo serviço em sua base de dados."
        setModalClose={onClose}
        submiteModal={handleFormSubmit(onSubmit)}

        nameIconMinimize={'Registrar Serviço'}
      >
        <S.Container>
          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Nome do Serviço
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe o serviço"
                type="text"
                {...register("name", { required: true })}
              />
              {errors.name && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>

            <S.FormInput>
              <S.Label>
                Valor da Venda R$
                <span>*</span>
              </S.Label>
              <Controller
                name="price"
                control={control}
                rules={{ required: "Este campo é obrigatório" }}
                render={({ field: { onChange, value, ref } }) => (
                  <NumericFormat
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale={true}
                    placeholder="R$ 0,00"
                    prefix="R$ "
                    value={value}
                    onValueChange={(values) => {
                      const purchaseValue = values.floatValue ?? 0;
                      onChange(purchaseValue);
                    }}
                    getInputRef={ref}
                  />
                )}
              />
              {errors.price && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>
          </S.SeparateDiv>

          <S.FormInput>
            <S.Label>Descrição</S.Label>
            <S.TextArea
              placeholder="Campo Opcional"
              rows={2}
              {...register("description")}
            />
          </S.FormInput>
        </S.Container>
      </LayoutModal>
    );
  }
  return null;
}